import { Component, OnInit, forwardRef, Input, Optional, Host, SkipSelf } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlContainer } from '@angular/forms';
import { FormComponentControl } from '../form-component-control';
import { inputMgsErrs } from 'src/app/validators/message-validation';

@Component({
  selector: 'app-input-gender-qq',
  templateUrl: './input-gender-qq.component.html',
  styleUrls: ['./input-gender-qq.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputGenderQqComponent),
      multi: true
    }
  ]
})
export class InputGenderQqComponent extends FormComponentControl  implements OnInit {
  @Input() isDisabled: boolean;
  @Input() name: any = 'gender';
  errors = inputMgsErrs.gender;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer
  ) {
    super(cc);
  }

  ngOnInit() {
    this.checkInitialControl();
  }

  selectGender(val) {
    if (!this.isDisabled) {
      this.value = val;
    }
  }

}
